document.querySelectorAll('[data-tw-review-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-tw-review-track]');
  const dots = Array.from(carousel.querySelectorAll('[data-tw-review-dot]'));
  if (!track || dots.length === 0) return;

  const slides = Array.from(track.children);

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    });
  });

  let ticking = false;
  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const active = slides.reduce(
        (closest, slide, index) => {
          const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          return distance < closest.distance ? { distance, index } : closest;
        },
        { distance: Infinity, index: 0 }
      ).index;

      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      ticking = false;
    });
  });
});
